import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, totalSteps, completedSteps }) => {
  const progressPercentage = (completedSteps / totalSteps) * 100;

  return (
    <div className="w-full bg-white rounded-lg shadow-subtle p-4 sm:p-6 mb-6 sm:mb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-brand rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="Navigation" size={20} color="white" />
          </div>
          <div>
            <h3 className="text-base sm:text-lg font-semibold text-primary">Data Maturity Assessment</h3>
            <p className="text-xs sm:text-sm text-muted-foreground">Step {currentStep} of {totalSteps}</p>
          </div>
        </div>
        <div className="text-left sm:text-right">
          <div className="text-xl sm:text-2xl font-bold text-secondary">{Math.round(progressPercentage)}%</div>
          <div className="text-xs sm:text-sm text-muted-foreground">Complete</div>
        </div>
      </div>
      
      <div className="w-full bg-surface rounded-full h-3 mb-4">
        <div 
          className="progress-bar h-3 rounded-full transition-all duration-500"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      
      <div className="hidden lg:flex justify-between text-xs text-muted-foreground">
        <span>Data Infrastructure</span>
        <span>Analytics Capabilities</span>
        <span>Governance Maturity</span>
        <span>Team Skills</span>
        <span>Strategic Alignment</span>
      </div>
    </div>
  );
};

export default ProgressIndicator;